'use strict';

module.exports = {
  number: 'number',
  text: 'text',
  icon: 'icon',
  percentage: 'percentage',
};
